import mountVues from "../mountVues";

common.View.create('galaxy::common.form.Postback', {

    /**
     * Called when DOM is ready.
     */
    onDOMLoad() {
        this.initPostback();
    },

    /**
     * Initializes the GUI.
     */
    initPostback()
    {
        // Get input
        let $input =  $('html, body').find('[name="' + this.element.data('input') + '"]'),
            $postbackGroups = this.element.find('.postbackGroup');

        // Check type input
        $input = this.getSpecificInput($input);

        // Find input that will activate the postback
        $input
            // On change event of that input
            .on('change', (event) => {
                // TODO Medium: Split into multiple functions

                // Loop element postback groups
                $postbackGroups.each((key, value) => {
                    // Get postback values
                    let postbackValues = $(value).find('> :first');

                    // Remove value wrapper so you don't have 'required' not focusable issues
                    if( postbackValues.is('div') ) {
                        postbackValues.remove();
                    }

                    // Hide group
                    $(value).hide();

                    // Is just a postback where you only show the item if an option is selected
                    // Or show this specific element?
                    let inputVal = this.getCurrentInputValue(event.currentTarget);
                    if( (inputVal && $(value).is('[data-value*="inputSelect"]')) ||
                        (!inputVal && $(value).is('[data-value*="inputNotSelect"]')) ||
                        $(value).is('[data-value="' + inputVal + '"]')
                    ) {
                        // Get template.
                        let template = $(value).find('noscript').text(),
                            templateWrapper = document.createElement('div');

                        // Remove script wrapper?
                        if(template.trim().startsWith('<script type="text/html">'))
                            template = template.trim().substr('<script type="text/html">'.length, template.length - '</script>'.length);

                        // Wrap in div
                        templateWrapper = $(templateWrapper).html(template);

                        // Add wrapper template and show div
                        $(value)
                            .prepend( templateWrapper )
                            .show();
                    }
                });

                // Re init vue
                mountVues(this.element);

                // Run trigger
                this.element.trigger('common-form-postback:change');

                // Re init view
                common.View.reinit();

            })
            .trigger('change')
            .end();
    },

    getSpecificInput($input)
    {
        // Is switch?
        if( $input.parents('[class*="galaxy::common-form-inputs"]').is('[class*="Switch"]') ) {
            $input = $($input.get(1));
        }

        return $input;
    },

    getCurrentInputValue(input)
    {
        // Is checkable?
        if( $.inArray($(input).attr('type'), ['checkbox', 'radio']) !== -1 ) {
            return $('input[name="' + input.name + '"]:checked').val();
        }

        return $(input).val();
    }

});